import { get } from 'lodash';

const styles = ({ color, typography, fontSize, margin, padding }) => ({
  deploymentsContainer: {
    backgroundColor: get(color, 'uiBackground'),
    width: '100%',
  },
  filterContainer: {
    marginTop: get(margin, 'm24'),
  },
  fieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
  },
  bodyContent: {
    padding: '0 36px',
  },
  selectField: {
    padding: '2px 10px !important',
  },
  deploymentCard: {
    display: 'inline-block',
    verticalAlign: 'top',
  },
  card: {
    margin: get(margin, 'm5'),
    minHeight: 160,
    marginLeft: get(margin, 'm0'),
  },
  cardTitle: {
    fontSize: get(fontSize, 'smallTitle'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    margin: '5px 0px',
  },
  cardType: {
    color: get(color, 'bodyText'),
    marginTop: get(margin, 'm5'),
    marginBottom: get(margin, 'm5'),
    verticalAlign: 'text-bottom',
    '& span': {
      verticalAlign: 'bottom',
      color: get(color, 'bodyText'),
      fontFamily: get(typography, 'bodyText'),
      margin: 'auto 0',
    },
  },
  cardStatus: {
    color: get(color, 'bodyText'),
    marginTop: get(margin, 'm5'),
    marginBottom: get(margin, 'm5'),
  },
  cardStatusIcon: {
    fontSize: 12,
  },
  cardLastUpdated: {
    color: get(color, 'smallText'),
    marginBottom: get(margin, 'm10'),
  },
  cardOldVersion: {
    color: get(color, 'smallText'),
    marginBottom: get(margin, 'm5'),
    fontWeight: 'bold',
  },
  cardUpdateVersion: {
    color: get(color, 'smallText'),
    marginLeft: get(margin, 'm15'),
    marginBottom: get(margin, 'm5'),
    marginTop: get(margin, 'm5'),
  },
  helpIcon: {
    fontSize: 12,
    margin: get(margin, 'm4'),
    verticalAlign: 'inherit',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
  helpTextContainer: {
    '& ui': {
      padding: 0,
      listStyleType: 'none',
    },
  },
  boldText: {
    fontWeight: 'bold',
  },
  linkWrapper: {
    '& a': {
      cursor: 'pointer',
      border: 'none !important',
      margin: `${get(margin, 'm0')} !important`,
      padding: `${get(padding, 'p0')} !important`,
      height: '0px !important',
      fontWeight: '300 !important',
      color: `${get(color, 'link')} !important`,
      fontSize: `${get(fontSize, 'bodyText')} !important`,
      fontFamily: `${get(typography, 'bodyText')} !important`,
      textDecoration: 'none',
    },
    '& a:hover': {
      color: `${get(color, 'linkHover')} !important`,
      textDecoration: 'none',
    },
    '& a:focus': {
      boxShadow: 'none !important',
      outline: '0px !important',
      textDecoration: 'none',
    },
  },
  actionLink: {
    margin: get(margin, 'm10'),
  },
  deploymentButtonsContainer: {
    margin: get(margin, 'm5'),
    '& button:first-of-type': {
      paddingLeft: `${get(padding, 'p10')} !important`,
    },
    '& button': {
      border: 'none',
      margin: get(margin, 'm0'),
      padding: get(padding, 'p0'),
      paddingRight: `${get(padding, 'p10')} !important`,
      paddingBottom: `${get(padding, 'p5')}  !important`,
      height: 'auto',
      lineHeight: '1 !important',
      fontWeight: '300 !important',
      color: `${get(color, 'link')} !important`,
      fontSize: `${get(fontSize, 'bodyText')} !important`,
      fontFamily: `${get(typography, 'bodyText')} !important`,
      verticalAlign: 'initial',
      textTransform: 'none',
      textDecoration: 'none',
    },
    '& button:hover': {
      color: `${get(color, 'linkHover')} !important`,
      textTransform: 'none',
      textDecoration: 'none',
    },
    '& button:focus': {
      boxShadow: 'none !important',
      outline: '0px !important',
      textTransform: 'none',
      textDecoration: 'none',
    },
  },
  checkStatusContainer: {
    margin: -5,
  },
  checkStatusButtonContainer: {
    display: 'block',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/GatewayBundle/Details/Deployments/styles.js